
import { supabase } from '@/integrations/supabase/client';
import { FoodRecipe, RecipeIngredient } from './types';

// Función auxiliar para convertir los beneficios en array si es necesario
const processRecipeData = (recipeData: any): FoodRecipe => {
  // Función de ayuda para procesar campos de beneficios
  const processBenefitsField = (field: string | string[] | null): string[] => {
    if (!field) return [];
    if (Array.isArray(field)) return field;
    // Si es un string, intentamos parsearlo como JSON
    try {
      const parsed = JSON.parse(field);
      return Array.isArray(parsed) ? parsed : [field];
    } catch (e) {
      // Si no es un JSON válido, lo tratamos como un solo string
      return [field];
    }
  };

  return {
    ...recipeData,
    benefits: processBenefitsField(recipeData.benefits),
    benefits_en: processBenefitsField(recipeData.benefits_en),
    benefits_es: processBenefitsField(recipeData.benefits_es),
    benefits_pt: processBenefitsField(recipeData.benefits_pt),
  };
};

export const getFoodRecipes = async (): Promise<FoodRecipe[]> => {
  try {
    console.log('Fetching all food recipes');
    const { data, error } = await supabase
      .from('food_recipes')
      .select('*')
      .returns<any[]>();
      
    if (error) {
      console.error('Error fetching recipes:', error);
      throw error;
    }
    
    console.log(`Successfully fetched ${data?.length || 0} recipes`);
    // Procesamos cada receta para garantizar que los beneficios sean arrays
    return Array.isArray(data) 
      ? data.map(recipe => processRecipeData(recipe)) 
      : [];
  } catch (error) {
    console.error('Error al obtener recetas:', error);
    return [];
  }
};

export const getRecipeIngredients = async (recipeId: string): Promise<RecipeIngredient[]> => {
  try {
    console.log('Fetching ingredients for recipe:', recipeId);
    
    const { data: recipeData, error: recipeError } = await supabase
      .from('food_recipes')
      .select('id')
      .eq('id', recipeId)
      .maybeSingle();
    
    if (recipeError) {
      console.error('Error verifying recipe existence:', recipeError);
    }
    
    if (!recipeData) {
      console.error('Recipe not found, cannot fetch ingredients:', recipeId);
      return [];
    }
    
    const { data, error } = await supabase
      .from('recipe_ingredients')
      .select(`
        *,
        ingredient:ingredient_id(name)
      `)
      .eq('recipe_id', recipeId)
      .returns<any[]>();
      
    if (error) {
      console.error('Error fetching recipe ingredients:', error);
      throw error;
    }
    
    console.log('Recipe ingredients data:', data);
    
    // Aseguramos que siempre devolvemos un array, incluso si data es null o undefined
    return Array.isArray(data) ? data.map(item => ({
      ...item,
      ingredient_name: item.ingredient?.name || 'Ingrediente desconocido'
    })) : [];
  } catch (error) {
    console.error('Error al obtener ingredientes de la receta:', error);
    return [];
  }
};
